var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "10px",
    viewBox: "0 0 5 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-alt-circle-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-51",
    transform: "translate(-405.000000, -187.000000)",
    fill: "#6D80A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(273.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-alt-circle-right",
    transform: "translate(132.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.70967742 L0,1.00806452 C0,0.576612903 0.52016129,0.362903226 0.826612903,0.665322581 L4.81854839,4.65725806 C5.00806452,4.84677419 5.00806452,5.15322581 4.81854839,5.34274194 L0.826612903,9.33467742 C0.52016129,9.64112903 0,9.4233871 0,8.99193548 L0,6.29032258 L0,3.70967742 Z",
    id: "Shape"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c4a7955d.svg";
export { ForwardRef as ReactComponent };